import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'textCutterPipe',
  standalone: true
})
export class TextCutterPipe implements PipeTransform {
  transform(inputString: string, stringLengthLimit = 80): string {
    const isStringTooLarge = inputString.length > stringLengthLimit;

    if (isStringTooLarge) {
      return inputString.substring(0, stringLengthLimit - 1) + '...';
    } else {
      return inputString;
    }
  }
}
